import { render, staticRenderFns } from "./FaceDirectionResultEffectFaceRight1.vue?vue&type=template&id=f8b3a908&"
import script from "./FaceDirectionResultEffectFaceRight1.vue?vue&type=script&lang=ts&"
export * from "./FaceDirectionResultEffectFaceRight1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports